export const pushCartToDataLayer = (products) => {
  window.dataLayer = window.dataLayer || [];

  const cartObject = {
    event: 'addToCart',
    ecommerce: {
      currencyCode: 'EUR',
      add: {
        products,
      },
    },
  };

  window.dataLayer.push(cartObject);
};

/**
 * @param {string} name
 * @param {string} sku
 * @param {string} price Price each
 * @param {string} brand
 * @param {string} lineName
 * @param {number} quantity
 * @param {string} amount Total price
 * @returns {{quantity: number, price: string, name: string, variant: string, id: string, category: string, brand: string}}
 */
export const createDataLayerProduct = (
  name,
  sku,
  price,
  brand,
  lineName,
  quantity,
  amount
) => {
  return {
    name,
    id: sku,
    price,
    category: 'Schakelmateriaal generator',
    brand,
    variant: lineName,
    quantity,
    amount,
  };
};
